import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { normalizeRepairReportDetail } from './normalizeRepairReportDetail';
import { serializeRepairReportCancelDraft } from './serialize';

/**
 * 取消維修報告草稿：未鎖定 DRAFT → CANCELLED（be doc f77b08e9）。
 * POST `/aftersales/repair-report/{id}/cancel-draft`；body `reason`＋`updatedAt`。
 * 品項回 PENDING，可再建立新草稿；取消的報告與附件不對客公開。
 *
 * @param {string} id
 * @param {{ reason?: string, updatedAt?: string, record?: { updatedAt?: string } }} payload
 */
export async function cancelDraftRepairReport(id, payload) {
  const { data: raw } = await request.post(
    `/aftersales/repair-report/${id}/cancel-draft`,
    serializeRepairReportCancelDraft(payload),
  );
  const parsed = parseVer4DetailResponse(raw);
  return {
    ...parsed,
    data: normalizeRepairReportDetail(parsed.data),
  };
}
